<script setup>
import {
  ref,
  watch,
  inject,
  defineProps,
  toRefs,
  defineExpose,
  nextTick,
} from "vue";
import i18n from "@/i18n";
import swiperTab from "@/components/common/swiperTab.vue";
import PreviewImg from "@/components/common/PreviewImg";
import { getLangValue } from "@/utils/common"; //获取后端语言
import { getDashboardIndex_radar_map } from "@/service/apiList/dashboard";
import { drawRadar } from "@/utils/chart.js";
import { getNewline, getLangValueByKey, formateValue } from "@/utils/common";
import nextIcon from "@/assets/images/products/disabled-next.png";
import prevIcon from "@/assets/images/products/disabled-prev.png";
import { useRoute } from "vue-router";
// const colors = ['#5470c6', '#91cc75', '#3ba272', '#ee6666', '#73c0de']
const optionsList = ref([]); //存储所有表信息
const detailInfo = inject("detailInfo");
const props = defineProps({
  groupList: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  p_id: {
    type: String,
    required: true,
    default: "",
  },
  i_name: {
    type: String,
    required: true,
    default: "",
  },
});
const showBtn = ref(false); // 显示左右按钮
const btnPostion = ref("left"); // 按钮滚动的位置
const indicatorstandardsList = ref([]);
const route = useRoute();
// const activeIndex = ref(0)
// const changeIndicator = (i) => {
//     activeIndex.value = i;
// }
const tabList = inject("tabList");
const current_tab_father = inject("current_tab");
const current_tab = ref("");
const current_tab1 = ref("");
const current_tab2 = ref("");
const index_standards_list = inject("index_standards_list");
const { groupList, p_id, i_name } = toRefs(props);
const groupList2 = ref([]);
const groupList3 = ref([]);
const showPreviewImg = ref(false);
// const detailInfo = inject('detailInfo')
const srcList = ref([]);
const radar_groupList = ref([]); // 雷达图
const chartData = ref({}); // 存储图表的数据
const productsFabric = ref({}); // 存储织物数据
const selectedFabricData = ref({}); // 选择的产品 织物数据
const loading = ref(false); // 雷达图加载效果
const handSelect = ref([]); // 手感
const skinSelect = ref([]); // 肤感

// const showFile = (fileList) => {
//     let ids = fileList.join(',')
//     getFileUrl({ attachments: ids }).then(res => {
//         res.payload.forEach(item => {
//             item.filename = item.name
//             item.type = setType(item.filename)
//         })
//         srcList.value = res.payload
//         showPreviewImg.value = true
//     })
// }
// const setType = (filename) => {
//     // 获取文件类型
//     let fileType = filename.split('.').pop()
//     if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
//         return 'image'
//     }
//     return 'file'
// }
const saveAs = (data, name) => {
  // const urlObject = window.URL || window.webkitURL || window;
  // const export_blob = new Blob([data.url]);
  // const save_link = document.createElement('a');
  // save_link.href = urlObject.createObjectURL(export_blob);
  // save_link.download = name;
  // save_link.click();
  // let host = _.trimEnd(_.trim(API_SVC_HOST, '""'), "/") + "/" + _.trimStart(url, "/");
  let url = data.url;
  // console.log(url)
  const x = new window.XMLHttpRequest();
  x.open("GET", url, true);
  x.responseType = "blob";
  x.onload = () => {
    const url = window.URL.createObjectURL(x.response);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.click();
  };
  x.send();
};
const groupAndSortByField = (arr) => {
  // return arr.reduce((acc, obj) => {
  //     const key = obj[field];
  //     if (!acc[key]) {
  //         acc[key] = [];
  //     }
  //     acc[key].push(obj);
  //     return acc;
  // }, {})
  //     .sort((a, b) => a[field].localeCompare(b[field]))
  //     .flatMap(group => group); // 如果需要将分组结果合并成一个数组
  let affv = [];
  const grouped = arr.reduce((result, obj) => {
    const group = obj.testing_institution;
    if (!result[group]) {
      result[group] = [];
    }
    result[group].push(obj);
    return result;
  }, {});
  // console.log(grouped);
  for (let k in grouped) {
    affv = [...affv, ...grouped[k]];
  }
  return affv;
};
const mouseOver = (item) => {
  item.showReference = true;
};
const mouseLeave = (event, item) => {
  // 获取鼠标离开时的元素
  let relatedTarget = event.relatedTarget;
  if (relatedTarget && relatedTarget.className == "popover-arrow") {
    return;
  }
  item.showReference = false;
};

const getValueByKey = (children, key, valueKey = "value") => {
  // 通过key来获取  不通过index 顺序修改了会报错
  if (children) {
    let obj = children.find((item) => item.key == key);
    return obj ? obj[valueKey] : "";
  }
  return "";
};
// watch(detailInfo, (val) => {
//     //设置自定义字段list
//     // console.log(val);
//     indicatorstandardsList.value = []
//     const { index_standard_info } = val
//     if (!index_standard_info || index_standard_info == null || Object.keys(index_standard_info).length == 0) return
//     for (let k in index_standard_info.value) {
//         let m = {
//             groupName: k,
//             indicatorList: index_standard_info.value[k] ? groupAndSortByField(index_standard_info.value[k], 'testing_institution') : [],
//         }
//         indicatorstandardsList.value.push(m)
//     }
//     if (indicatorstandardsList.value.length == 0) {
//         tabList.value[2].show = false;
//         current_tab.value = 0
//     }
// },)

const changTab = () => {
  // 根据current_tab 设置子集信息
  let arr = current_tab.value.split("_");
  if (arr.length == 2) {
    // 代表第一级  需要联动第二级  第三级
    // 第二级
    groupList2.value = groupList.value.groupList2.filter((item) =>
      item.id.includes(current_tab.value)
    );
    // 第三级
    groupList3.value = groupList.value.groupList3.filter((item) =>
      item.id.includes(current_tab.value)
    );
    current_tab1.value = "";
    current_tab2.value = "";
  } else if (arr.length == 3) {
    // 代表第二级  需要联动第三级
    // 第三级
    groupList3.value = groupList.value.groupList3.filter((item) =>
      item.id.includes(current_tab.value)
    );
    current_tab2.value = "";
  }
};

const setGroupName = async (data) => {
  // 设置数据
  radar_groupList.value = data.filter((item) => item.name != "综合");
  showBtn.value = radar_groupList.value.length >= 4 ? true : false; // 显示左右切换按钮
  // console.log(radar_groupList.value);
};
//递归数据修改
const recursiveFind = (items, id) => {
  for (const item of items) {
    if (item.id === id) {
      return item; // 找到对象，返回
    }
    // 如果有子项，递归查找
    if (item.layer_list) {
      const found = recursiveFind(item.layer_list, id);
      if (found) {
        return found; // 找到子项，返回
      }
    }
  }
  return null; // 未找到，返回 null
};
const serChartSeriesValue = (name) => {
  // 设置图标series 数据
  let seriesObj = [
    {
      type: "radar",
      tooltip: {
        trigger: "item",
      },
      radarIndex: 0,
      // areaStyle: {},
      data: [],
    },
  ];
  let avgValueList = []; // 存储均值数据
  let legendData = [];
  // console.log(chartData.value);
  for (const item in chartData.value) {
    const list = chartData.value[item].data;
    let arr = list.filter((item) => item.name == name);
    console.log(arr, productsFabric.value);
    if (arr.length) {
      let children = arr[0].children;
      if (selectedFabricData.value[`chart-${name}`]) {
        let arr = productsFabric.value[`${name}-list`];
        // let obj = arr.find(
        //   (iittem) => iittem.id === selectedFabricData.value[`chart-${name}`]
        // );
        let obj = recursiveFind(arr, selectedFabricData.value[`chart-${name}`]);
        if (obj && obj.children) {
          children = obj.children; //使用当前的选中织物的信息
        }
      }
      children.sort((a, b) => {
        // 将 name 为 "综合" 的对象排到最前面
        if (a.name === "综合" && b.name !== "综合") return -1;
        if (a.name !== "综合" && b.name === "综合") return 1;
        return 0; // 其他元素保持原始顺序
      });
      let children_value_lsit = children.map((item1) => item1.value);
      // console.log(children_value_lsit);
      seriesObj[0].data.push({
        name: chartData.value[item].name,
        value: children_value_lsit,
        // color: chartData.value[item].color,
        // 线条颜色
        lineStyle: {
          color: chartData.value[item].color,
        },
        // 图形颜色  影响legend
        itemStyle: {
          color: chartData.value[item].color,
        },
      });
      legendData.push(chartData.value[item].name);
      // console.log(avgValueList.length);
      if (avgValueList.length == 0) {
        avgValueList = children.map((item1) => item1.avg_value);
        seriesObj[0].data.push({
          name: getLangValue("dashboard.avg_value"),
          value: avgValueList,
          lineStyle: {
            color: "#7F7F7F",
          },
          itemStyle: {
            color: "#7F7F7F",
          },
        });
        legendData.push(getLangValue("dashboard.avg_value"));
      }
    }
  }
  // 排序将均值排在最后面
  legendData.sort((a, b) => {
    if (
      a === getLangValue("dashboard.avg_value") &&
      b !== getLangValue("dashboard.avg_value")
    )
      return 1;
    if (
      a !== getLangValue("dashboard.avg_value") &&
      b === getLangValue("dashboard.avg_value")
    )
      return -1;
    return 0; // 其他元素保持原始顺序
  });
  return { seriesObj, legendData };
};

const isScrolledToRight = (element) => {
  //是否到达右边
  btnPostion.value =
    element.scrollLeft + element.clientWidth >= element.scrollWidth
      ? "right"
      : "";
  return element.scrollLeft + element.clientWidth >= element.scrollWidth;
};

const isScrolledToLeft = (element) => {
  //是否到达左边
  btnPostion.value = element.scrollLeft === 0 ? "left" : "";
  return element.scrollLeft === 0;
};

const prev = () => {
  //上一个
  //验证是否到达左边
  const element = document.getElementById("chart-group-" + p_id.value);
  if (isScrolledToLeft(element)) return;
  const scrollAmount = element.clientWidth * 0.3; // 滑动30% 显示上一个chart 因为我设置的宽度30%
  element.scrollTo({
    left: element.scrollLeft - scrollAmount,
    behavior: "smooth",
  });
};

const next = () => {
  //下一个
  //验证是否到达右边
  const element = document.getElementById("chart-group-" + p_id.value);
  if (isScrolledToRight(element)) return;
  const scrollAmount = element.clientWidth * 0.3; // 滑动30% 显示下一个chart 因为我设置的宽度30%
  element.scrollTo({
    left: element.scrollLeft + scrollAmount,
    behavior: "smooth",
  });
};

const getRadarData = async () => {
  loading.value = true;
  // 获取雷达图数据
  const category_name = groupList.value.category_name_info[current_tab.value];
  // console.log(category_name);
  if (!category_name) return;
  const id = route.query.id;
  // 开始获取数据
  // 获取雷达图数据
  let params = {
    category_id: category_name, // 质量
    id: id,
  };
  // 如果是公开数据库 才需要传入is_public:1
  if (!route.query.p_id && !route.query.origin) {
    params.is_public = 1;
  }
  const resp = await getDashboardIndex_radar_map(params);
  loading.value = false;
  // 保存数据
  const data = removeDuplicatesByName(resp.payload);
  const basiInofo = detailInfo.value.product_info.children.find(
    (item) => item.key == "product_info_base_info"
  );
  const name = getValueByKey(
    basiInofo.children,
    "product_info_base_info_product_name"
  );
  chartData.value = {};
  chartData.value[category_name] = {
    name: name,
    data: data,
    indicator_standard_list: resp.payload.specific_index_standard_list,
  };
  // 判断是否有织物
  resp.payload.radar_map.forEach((element) => {
    // 某个有值 说明是手感与肤感
    if (element.layer_list?.length) {
      productsFabric.value[`${element.name}-list`] = element.layer_list; // 选择的织物list
      selectedFabricData.value[`chart-${element.name}`] = ""; //选择的织物
    }
  });
  // 获取组名
  await setGroupName(data);
  // 重新绘制图表
  nextTick(() => {
    showCharts();
    // 设置手感 肤感 热湿舒适度值
    for (const item in productsFabric.value) {
      let layerList = productsFabric.value[item];
      if (layerList.length) {
        let key = item.split("-").length ? item.split("-")[0] : "";
        if (key) {
          selectedFabricData.value[`chart-${key}`] = layerList[0].id; // 选择的织物
          handSelect.value = [layerList[0].id]
          skinSelect.value = [layerList[0].id]
        }
      }
    }
  });
};
const removeDuplicatesByName = (data) => {
  const seenNames = new Set();
  const uniqueRadarMap = data.radar_map.filter((item) => {
    if (!seenNames.has(item.name)) {
      seenNames.add(item.name);
      return true; // 保留当前项
    }
    return false; // 去掉重复项
  });

  // 返回去重后的数据对象
  return uniqueRadarMap;
};

const showCharts = () => {
  // 展示图表
  optionsList.value = [];
  for (const item in radar_groupList.value) {
    let { seriesObj: data, legendData: legendData } = serChartSeriesValue(
      radar_groupList.value[item].name
    );
    // console.log(data);
    //设置三个图表
    const { children } = radar_groupList.value[item];
    let indicatorList = children.map((item) => {
      return {
        name:
          i18n.global.locale == "en"
            ? getNewline(item.name_en, 16)
            : getNewline(item.name, 16),
        name1: item.name,
        name1_en: item.name_en,
        max: 1,
      };
    });
    let option = {
      // color: colors,
      tooltip: {
        trigger: "axis",
        confine: true,
        formatter: function (params) {
          let str = ` <div style='color: ${params.color};font-weight: bold'>${params.name}</div>`;
          for (const item in params.value) {
            str += `
                        <div>
                        <div style='min-width:100px; text-align:left; display:inline-block'>
                            ${
                              i18n.global.locale == "en"
                                ? indicatorList[item].name1_en
                                : indicatorList[item].name1
                            }
                        </div>
                            :
                         <div style='min-width:100px; text-align:left; display:inline-block'>${
                           params.value[item] == null ? "-" : formateValue(params.value[item])
                         }</div>
                    </div>`;
          }
          return str;
        },
      },
      legend: {
        data: legendData,
        bottom: 0,
      },
      radar: {
        indicator: indicatorList,
        radius: indicatorList.length == 2 ? 80 : 100, // 2个角必须小一点否则就撑满了
        // 同时需要调整一下显示位置
        center:
          indicatorList.length == 2
            ? ["50%", "45%"]
            : indicatorList.length == 3
            ? ["50%", "55%"]
            : ["50%", "50%"],
        splitLine: {
          //里面四个圈线条样式
          lineStyle: {
            color: [
              "rgba(169,169,169, 1)",
              "rgba(232, 236,244, 1)",
              "rgba(232, 236,244, 1)",
              "rgba(232, 236,244, 1)",
              "rgba(232, 236,244, 1)",
            ], //分别对应四个第一个对应最里面的圈
            width: 2,
          },
        },
        axisLine: {
          lineStyle: {
            color: "rgba(169,169,169, 1)",
            width: 2, // 轴线宽度
          },
        },
        axisName: {
          color: "black",
          fontSize: 14,
        },
        axisLabel: {
          show: true,
          formatter: function (value, index) {
            // 只在最后一个角显示最大值
            if (index === 5) {
              return value;
            } else {
              return "";
            }
          },
          margin: 10,
        },
      },

      // [
      //     {
      //         indicator: indicatorList,
      //         radius: 100
      //     }
      // ],
      series: data,
    };
    optionsList.value.push({ option, indicatorList }); //把图表数据存储起来
    // console.log(option);
    // visible.value = true
    nextTick(() => {
      let dom = document.getElementById(`groupChart_${item}_${p_id.value}`);
      dom.setAttribute("_echarts_instance_", "");
      drawRadar(dom, option);
    });
  }
};
const showBigChart = () => {
  // 展示大图
  // visible.value = true
  // title.value = groupList.value[key].name ? `${i18n.global.t('dashboard.comfort.performance_of_pef_Indicator_Grouping')}-${groupList.value[key].name}` : i18n.global.t('dashboard.comfort.performance_of_pef_Indicator_Grouping');
  // nextTick(() => {
  //     let dom = document.getElementById(`myChartsRef`)
  //     dom.setAttribute('_echarts_instance_', '')
  //     let { option, indicatorList } = optionsList.value[key];
  //     // 修改部分信息
  //     option.radar.radius = 150;
  //     option.radar.center = ['50%', '50%'];
  //     // 修改名称 不需要换行了
  //     option.radar.indicator = indicatorList.map(item => {
  //         return {
  //             name: item.name1,
  //             max: item.max
  //         }
  //     });
  //     drawRadar(dom, option)
  // })
};

const onActiveTabId = (id) => {
  current_tab.value = id;
};

const setInstarand = () => {
  // 设置指标信息
  for (const item in selectedFabricData.value) {
    const arr = groupList2.value.filter((item) => item.id == current_tab.value);
    let name = arr.length ? arr[0].name : "";
    // 名称进行匹配  手感中文
    if (
      item.includes(getLangValueByKey("menu.hand-feeling")) &&
      name == getLangValueByKey("menu.hand-feeling")
    ) {
      if (selectedFabricData.value[item]) {
        // 设置手感的数据
        let id = selectedFabricData.value[item];
        // 获取手感的数据
        let data = detailInfo.value.structure_index_standard_list.filter(
          (item22) => item22.id == id
        );
        if (data.length > 0) {
          let group_list = data[0].group_list;
          let hand_feeling_data = group_list.filter(
            (aa) => aa.group_name == getLangValueByKey("menu.hand-feeling")
          );
          let index_standards = hand_feeling_data[0].index_standards;
          indicatorstandardsList.value.map((item11) => {
            let data1 = index_standards.filter((aa) => aa.name == item11.name);
            item11.oldVal = item11.value;
            if (data1.length) {
              item11.value = data1[0].value;
            }
          });
        }
      } else {
        // 恢复原来的数据
        indicatorstandardsList.value.map((item11) => {
          item11.value = item11.oldVal;
        });
      }
    }
    // console.log(indicatorstandardsList.value);
    // 名称进行匹配  肤感中文
    if (
      item.includes(getLangValueByKey("menu.skin-feeling")) &&
      name == getLangValueByKey("menu.skin-feeling")
    ) {
      if (selectedFabricData.value[item]) {
        // 设置肤感的数据
        let id = selectedFabricData.value[item];
        // 获取肤感的数据
        let data = detailInfo.value.structure_index_standard_list.filter(
          (item) => item.id == id
        );
        if (data.length > 0) {
          let group_list = data[0].group_list;
          let hand_feeling_data = group_list.filter(
            (aa) => aa.group_name == getLangValueByKey("menu.skin-feeling")
          );
          let index_standards = hand_feeling_data[0].index_standards;
          indicatorstandardsList.value.map((item11) => {
            let data1 = index_standards.filter((aa) => aa.name == item11.name);
            item11.oldVal = item11.value;
            if (data1.length) {
              item11.value = data1[0].value;
            }
          });
        }
      } else {
        // 恢复原来的数据
        indicatorstandardsList.value.map((item11) => {
          item11.value = item11.oldVal;
        });
      }
    }
    // 名称进行匹配  热湿舒适度中文
    if (
      item.includes(getLangValueByKey("menu.thermal-moisture-comfort")) &&
      name == getLangValueByKey("menu.thermal-moisture-comfort")
    ) {
      if (selectedFabricData.value[item]) {
        // 获取热湿舒适度的数据
        let id = selectedFabricData.value[item];
        // 获取热湿舒适度的数据
        let data = detailInfo.value.structure_index_standard_list.filter(
          (item) => item.id == id
        );
        if (data.length > 0) {
          let group_list = data[0].group_list;
          let hand_feeling_data = group_list.filter(
            (aa) =>
              aa.group_name ==
              getLangValueByKey("menu.thermal-moisture-comfort")
          );
          let index_standards = hand_feeling_data[0].index_standards;
          indicatorstandardsList.value.map((item11) => {
            let data1 = index_standards.filter((aa) => aa.name == item11.name);
            item11.oldVal = item11.value;
            if (data1.length) {
              item11.value = data1[0].value;
            }
          });
        }
      } else {
        // 恢复原来的数据
        indicatorstandardsList.value.map((item11) => {
          item11.value = item11.oldVal;
        });
      }
    }
  }
};
const handleChange = (name, e) => {
  selectedFabricData.value[`chart-${name}`] = e[e.length - 1];
  console.log(selectedFabricData.value);
};
watch(
  groupList,
  () => {
    // 设置一级信息 设置二级信息
    if (groupList.value.groupList2)
      groupList2.value = groupList.value.groupList2.filter((item) =>
        item.id.includes(p_id.value)
      );
    if (groupList.value.groupList3)
      groupList3.value = groupList.value.groupList3.filter((item) =>
        item.id.includes(p_id.value)
      );
    // console.log(index_standards_list.value);
    // 默认显示第一级数据
    current_tab.value = p_id.value;
  },
  { deep: true, immediate: true }
);

watch(
  current_tab,
  () => {
    changTab();
    // 设置数据
    // console.log(index_standards_list.value);
    indicatorstandardsList.value = JSON.parse(
      JSON.stringify([
        ...groupAndSortByField(
          index_standards_list.value[current_tab.value].indicatorList
        ),
      ])
    );
    // 获取数据
    setInstarand();
    // 便利数据
  },
  { immediate: true }
);

watch(current_tab_father, (val) => {
  if (
    tabList.value[val]?.type == "instandard" &&
    i_name.value == tabList.value[val]?.name
  ) {
    radar_groupList.value = [];
    getRadarData(); // 当前指标
  }
});

defineExpose({
  current_tab,
});

watch(
  selectedFabricData,
  () => {
    showCharts();
    setInstarand();
  },
  { deep: true }
);

// 监听数据 如果数据长度为0  则不显示tab
// watch(() => indicatorstandardsList.value.length, (val) => {
//     // console.log(val);
//     if (val == 0) {
//         // console.log(tabList);
//         tabList.value[2].show = false;
//         current_tab.value = 0
//     }
// }, { immediate: true })
</script>
<template>
  <!-- style="border: 1px solid #E9EBEC;" -->
  <div class="indicatorstandards p-2" v-loading="loading">
    <swiperTab
      @onActiveTabId="onActiveTabId"
      class="ms-4"
      :groupList="groupList2"
      v-model:current_tab="current_tab1"
      :tabKey="'group2'"
      :currentTabLang="i18n.global.locale == 'en' ? 2 : 1"
    />
    <swiperTab
      @onActiveTabId="onActiveTabId"
      class="ms-6"
      :groupList="groupList3"
      v-model:current_tab="current_tab2"
      :tabKey="'group3'"
      :currentTabLang="i18n.global.locale == 'en' ? 2 : 1"
    />
    <!-- 雷达图 -->
    <div
      class="center mt-3 d-flex flex-column my-scroll-bar"
      v-if="radar_groupList.length"
    >
      <div class="card px-3 py-2">
        <div class="my-card-header">
          {{
            getLangValue(
              "product-management",
              "performance_of_indicator_grouping"
            )
          }}
        </div>
        <hr
          class="my-2"
          style="
            background-color: #e9ebec;
            opacity: 1;
            border-top: 1px solid #e9ebec;
          "
        />
        <!-- 图表数据 -->
        <div
          class="my-group-charts d-flex justify-content-between align-items-center"
          style="margin-top: -6px"
        >
          <div
            style="width: 14px; display: inline-block"
            v-if="showBtn && btnPostion != 'left'"
            class="me-2"
          >
            <img
              :src="prevIcon"
              style="width: 16px; height: auto"
              @click="prev()"
              class="cursor-pointer"
            />
          </div>
          <div
            :id="`chart-group-${p_id}`"
            style="
              display: block;
              overflow: hidden;
              box-sizing: border-box;
              margin: 0 auto;
              padding: 0;
              white-space: nowrap;
              flex: 1;
            "
            v-if="radar_groupList.length"
          >
            <div
              style="
                display: inline-block;
                width: 33%;
                height: 400px;
                position: relative;
              "
              class="mx-2 chart-item"
              v-for="(item, key) in radar_groupList"
              :key="key"
            >
              <div
                :id="`groupChart_${key}_${p_id}`"
                style="width: 100%; height: 370px"
                @dblclick="showBigChart(key)"
              ></div>
              <div style="text-align: center">
                <span class="cursor-pointer">{{
                  i18n.global.locale == "en" ? item.name_en : item.name
                }}</span>
              </div>
              <!-- 筛选条件 -->
              <div
                class=""
                style="position: absolute; top: 0; left: 30px"
                v-if="item.layer_list"
              >
                <template v-if="productsFabric[`${item.name}-list`]?.length">
                  <div
                    class="mt-2"
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <div>
                      {{ getLangValue("dashboard.comfort.fabric_name") }}：
                    </div>

                    <!-- <el-select v-model="selectedFabricData[`chart-${item.name}`]" filterable clearable
                                       placeholder="" class="me-2" style="min-width: 110px; height: 38px;" size='mini'>
                                       <el-option v-for="item in productsFabric[`${item.name}-list`]" :key="item.value"
                                           :label="item.name" :value="item.id" />
                                   </el-select> -->
                    <el-cascader
                    
                      v-if="key == 0"
                      filterable
                      size="small"
                      style="width: 250px"
                      v-model="handSelect"
                      :options="productsFabric[`${item.name}-list`]"
                      :props="{
                        label: 'name',
                        value: 'id',
                        children: 'layer_list',
                      }"
                      class="my-el"
                      @change="handleChange(item.name, $event)"
                      :show-all-levels="false"
                    />
                    <el-cascader
                      v-if="key == 1"
                      filterable
                      size="small"
                      style="width: 250px"
                      v-model="skinSelect"
                      :options="productsFabric[`${item.name}-list`]"
                      :props="{
                        label: 'name',
                        value: 'id',
                        children: 'layer_list',
                      }"
                      class="my-el"
                      @change="handleChange(item.name, $event)"
                      :show-all-levels="false"
                    />
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div
            style="width: 14px; display: inline-block; text-align: right"
            v-if="showBtn && btnPostion != 'right'"
            class="ms-2"
          >
            <img
              :src="nextIcon"
              style="width: 16px; height: auto"
              @click="next"
              class="cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>
    <Empty
      v-else
      :content="getLangValue('base.no_radar_data')"
      style="margin: 20px 0 !important"
    ></Empty>
    <div
      v-if="
        index_standards_list[current_tab] &&
        index_standards_list[current_tab].indicatorList.length
      "
    >
      <!-- <div class="d-flex justify-content-start py-4">
                <div class="flex mx-2 cursor-pointer" v-for="(item, k) in indicatorstandardsList" :key="k"
                    @click="changeIndicator(k)" :class="activeIndex == k ? 'active' : ''">
                    {{ item.groupName }}
                </div>
            </div> -->
      <table class="table" border>
        <thead>
          <tr>
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>{{ getLangValue("hscode.indicatorName") }}</div>
            </th>
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>{{ getLangValue("attribute.value") }}</div>
            </th>
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>{{ getLangValue("attribute.unit") }}</div>
            </th>
            <!-- <th class="px-2" scope="col" width="20%"
                            style="border-right: 1px solid #E9EBEC;font-weight: bold;">
                            <div>{{ $t('attribute.reference') }}</div>
                        </th> -->
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>
                {{ getLangValue("product-template", "testingOrganization") }}
              </div>
            </th>
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>
                {{
                  getLangValue(
                    "product-template",
                    "testingOrganizationQualification"
                  )
                }}
              </div>
            </th>
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>{{ getLangValue("product-template", "testDate") }}</div>
            </th>
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>
                {{ getLangValue("product-template", "testinginstitutions") }}
              </div>
            </th>
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>
                {{ getLangValue("product-template", "testinginstitutions1") }}
              </div>
            </th>
            <!-- <th class="px-2" scope="col" width="10%"
                            style="border-right: 1px solid #E9EBEC;font-weight: bold;">
                            <div>{{ getLangValue('product-template', 'remark') }}</div>
                        </th>2024-09-20去掉备注信息 -->
            <th
              class="px-2"
              scope="col"
              width="10%"
              style="border-right: 1px solid #e9ebec; font-weight: bold"
            >
              <div>{{ getLangValue("product-template", "report") }}</div>
            </th>
            <!-- <th class="px-2" scope="col" width="10%" style="border-right: 1px solid #E9EBEC;font-weight: bold;">
                            <div>{{ getLangValue('product-template', 'annex') }}</div>
                        </th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tableItem, kk) in indicatorstandardsList" :key="kk">
            <td style="border-right: 1px solid #e9ebec" scope="row">
              {{
                i18n.global.locale == "en" ? tableItem.name_en : tableItem.name
              }}
              <i
                :id="tableItem.id + tableItem.name"
                class="ri-question-line"
                @mouseover="mouseOver(tableItem)"
                @mouseleave="mouseLeave($event, tableItem)"
              ></i>
              <b-popover
                :target="tableItem.id + tableItem.name"
                v-model:show="tableItem.showReference"
                triggers=""
              >
                <div
                  :ref="`reference${tableItem.name}`"
                  style="min-width: 200px"
                  @mouseleave="tableItem.showReference = false"
                >
                  <b-form-textarea
                    v-show="i18n.global.locale == 'ch'"
                    v-model="tableItem.reference"
                    disabled
                    :placeholder="getLangValue('attribute.reference')"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-textarea
                    v-show="i18n.global.locale == 'en'"
                    v-model="tableItem.reference_en"
                    disabled
                    :placeholder="getLangValue('attribute.reference')"
                    rows="3"
                  ></b-form-textarea>
                </div>
              </b-popover>
            </td>
            <td style="border-right: 1px solid #e9ebec">
              {{ tableItem.value }}
            </td>
            <td style="border-right: 1px solid #e9ebec">
              {{
                i18n.global.locale == "en" ? tableItem.unit_en : tableItem.unit
              }}
            </td>
            <!-- <td style="border-right: 1px solid #E9EBEC;">{{ tableItem.reference }}</td> -->
            <td style="border-right: 1px solid #e9ebec">
              {{ tableItem.testing_institution }}
            </td>
            <td style="border-right: 1px solid #e9ebec">
              {{ tableItem.qualification_of_testing_institution }}
            </td>
            <td style="border-right: 1px solid #e9ebec">
              {{ tableItem.certification_date }}
            </td>
            <td style="border-right: 1px solid #e9ebec">
              {{ tableItem.validity_period_of_certification }}
            </td>
            <td style="border-right: 1px solid #e9ebec">
              {{ tableItem.certification_body }}
            </td>
            <!-- <td style="border-right: 1px solid #E9EBEC;">{{ tableItem.remark }}</td>2024-09-20去掉备注信息 -->
            <td style="border-right: 1px solid #e9ebec">
              <!-- {{ tableItem.has_report }} -->
              <div v-if="tableItem.report && tableItem.report.length">
                <!-- {{ tableItem.fileList.map(item => item.filename).join(",") }} -->
                <el-popover
                  v-if="
                    tableItem.extra?.fileList &&
                    tableItem.extra?.fileList.length
                  "
                  placement="left-start"
                  :title="getLangValue('upload.uploadedFile')"
                  :width="600"
                  trigger="click"
                >
                  <template #reference>
                    <i class="ri-file-upload-line cursor-pointer"></i>
                  </template>
                  <div
                    style="width: 600px"
                    v-for="(file, i) in tableItem.extra.fileList"
                    :key="i"
                    class="d-flex align-items-center"
                  >
                    {{ file.filename }}
                    <!-- <el-button size="small" type="text" style="margin-left: 5px;"
                                    @click="deleteFile(tableItemindicator_index, i)">
                                    {{ $t("base.delete") }}
                                </el-button> -->
                    <i
                      class="fs-16 ri-file-download-fill cursor-pointer"
                      style="color: #f06548; margin-left: 10px"
                      @click="saveAs(file, file.filename)"
                    ></i>
                  </div>
                </el-popover>
              </div>
            </td>

            <!-- <td style="border-right: 1px solid #E9EBEC;">{{ tableItem.remark }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>
    <Empty
      v-else
      :content="getLangValue('base.no_indicator_data')"
      style="margin: 20px 0 !important"
    ></Empty>
    <PreviewImg
      v-model:showPreviewImg="showPreviewImg"
      :srcList="srcList"
      v-if="showPreviewImg"
    ></PreviewImg>
  </div>
</template>
<style scoped>
.active {
  color: #0ab39c;
}

.chart-item {
  border-right: 1px solid #d9d9d980;

  &:last-child {
    border-right: none;
  }
}

:deep(.el-select__placeholder.is-transparent) {
  font-size: 0.8125rem;
  color: #878a99 !important;
}

:deep(.el-cascader .el-input__inner) {
  &::placeholder {
    font-size: 0.8125rem;
    color: #878a99 !important;
  }
}

:deep(.el-select__selected-item.el-select__placeholder) {
  font-size: 0.8125rem;
  color: #212529;
}
</style>
